export default __webpack_public_path__ + "static/media/premium1.31bf2759.png";